import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BenefitInvoice } from '@models/benefits/benefit-invoice.model';

export class ProviderColumn extends Column {
    title = 'benefits.benefitsPayroll.provider';
    property = 'provider';
    type: CellDisplay = CellDisplay.string;

    getDisplayPropertyValue(benefitInvoice: BenefitInvoice): string | null {
        return benefitInvoice.benefitProvider?.name ?? '';
    }
}
